import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statItems = [
    {
      icon: 'Video',
      label: 'Total des vidéos',
      value: stats?.totalVideos,
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      icon: 'CheckCircle2',
      label: 'Vidéos terminées',
      value: stats?.completedVideos,
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
   
    {
      icon: 'TrendingUp',
      label: 'Progression',
      value: `${stats?.progress}%`,
      color: 'text-warning',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {statItems?.map((item, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-lg p-4 hover:shadow-card transition-shadow duration-200"
        >
          <div className="flex items-center gap-3">
            <div className={`w-12 h-12 rounded-lg ${item?.bgColor} flex items-center justify-center`}>
              <Icon name={item?.icon} size={24} color={`var(--color-${item?.color?.replace('text-', '')})`} />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">{item?.label}</p>
              <p className={`text-2xl font-semibold ${item?.color}`}>{item?.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;